import {
    cleanCommonParams,
} from './common';

const mapAgencyLocationParams = (
    isCreate,
    {
        premier_access_group_id,
        agency_id,
        creator_id,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            agency_location: {
                ...cleanCommonParams(params),
            },
        });
    });
};

export { mapAgencyLocationParams };
